import React, { type PropsWithChildren, type ReactNode } from 'react';

const hasRenderableChildren = (children: React.ReactNode): boolean => {
    const array = React.Children.toArray(children);

    // At least one child that is not null, undefined, or false
    return array.some((child) => {
        if (
            child === null ||
            child === undefined ||
            (typeof child === 'boolean' && child === false)
        )
            return false;

        // string, number, valid JSX, fragments, etc. are fine
        return (
            typeof child === 'string' || typeof child === 'number' || React.isValidElement(child)
        );
    });
};

const RenderableChildrenWrapper = (
    props: PropsWithChildren<{ render: (ch: ReactNode) => React.ReactNode }>,
) => {
    if (hasRenderableChildren(props.children)) {
        return <>{props.render(props.children)}</>;
    }

    return null;
};

export default RenderableChildrenWrapper;
